import type { Collaborator } from '@components/ArtBoard/Collaboration/types'
import { Avatar, GuestAvatar } from '@octopus-do/octopus-storybook'

import css from './styles.module.css'

interface AvatarRendererProps {
  collaborator: Collaborator
}

export const AvatarRenderer = ({ collaborator }: AvatarRendererProps) => {
  const getAvatarMedia = (media: string | null) => media || null

  return (
    <div className={css.avatar_wrapper}>
      {!collaborator.userId ? (
        <GuestAvatar color={collaborator.color} />
      ) : (
        <Avatar
          name={`${collaborator.firstName} ${collaborator.lastName}`}
          color={collaborator.color}
          media={getAvatarMedia(collaborator.avatar)}
        />
      )}
    </div>
  )
}
